import i18n from "i18n";
import { capitalize } from "helpers/utils/utils_general";

const scopes = [
    {
        name: capitalize(i18n.t("items")),
        id: 'item',
    },
    {
        name: capitalize(i18n.t("brands")),
        id: 'brand'
    },
    {
        name: capitalize(i18n.t("categories")),
        id: 'category'
    },
    {
        name: capitalize(i18n.t("persons")),
        id: 'person'
    },
    {
        name: capitalize(i18n.t("branch.offices")),
        id: 'node'
    },
    {
        name: capitalize(i18n.t("locations")),
        id: 'location'
    },
    {
        name: capitalize(i18n.t("orders")),
        id: 'order'
    },
    {
        name: capitalize(i18n.t("stock.movement")),
        id: 'movement'
    }
  ]

export default scopes;